import { Common, color, device } from '@stockbit/ui';
import CorpActionTag from 'global/CorpAction/CorpActionTag';
import Image from 'global/Image';
import Notation from 'global/Notation';
import styled, { css } from 'styled-components';
import ExpandButtonToggle from '../Chart/ExpandButtonToggle';

const { Button, Flex, Text } = Common;

export const Header = styled.div`
  background: ${color.light};
  border: 1px solid ${color.gainsboro};
  margin-bottom: 20px;
  padding: 20px;
`;

export const CompanyHeader = styled.section`
  display: flex;
  flex-direction: column;
`;

// eslint-disable-next-line space-infix-ops
export const CountryFlag = styled(Image)`
    display: block;
    left: -1px;
    margin: 0;
    padding: 0;
    position: relative;
    top: -1px;
    width: calc(100% + 2px);
`;

export const ButtonFollow = styled(Button)`
  padding: 2px 8px;
  width: 100px;

  @media ${device.tablet} {
    padding: 4px 15px;
  }
`;

export const ColumnMobile = styled(Flex)`
  flex-direction: column;

  @media ${device.tablet} {
    flex-direction: row;
  }

  &.start-center {
    align-items: flex-start;

    @media ${device.tablet} {
      align-items: center;
    }
  }

  &.end-center {
    align-items: flex-end;

    @media ${device.tablet} {
      align-items: center;
    }
  }
`;

export const Percentage = styled(Text).attrs({ size: '13px', family: 'bold' })`
  @media ${device.tablet} {
    margin-left: 5px;
  }
`;

export const Value = styled(Text).attrs({ size: '18px', color: color.black, family: 'bold' })`
  text-transform: lowercase;
  word-wrap: anywhere;
`;


const IMAGE_PLACEHOLDER_COLOR = '#3A645C';
export const ImagePlaceholder = styled.span`
  background-color: ${IMAGE_PLACEHOLDER_COLOR};
  border-radius: 70px;
  color: ${color.light};
  display: flex;
  margin: auto;
  min-height: 54px;
  min-width: 54px;

  > small {
    font-family: 'Proxima Nova', sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 27px;
    margin: auto;
    text-align: center;
  }
`;

export const Symbol = styled.h3`
  display: inline-block;
  font-family: "ProximaNovaBd";
  font-size: 16px;
  font-weight: bold;
  margin: 0;
  max-width: calc(100% - 30px);
  overflow: hidden;
  padding: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const NotationCountryFlagContainer = styled.div`
  display: inline-block;
`;

export const CountryFlagContainer = styled.span`
  border: 1px solid ${color.veryLightGrey};
  border-radius: 50%;
  display: inline-block;
  height: 18px;
  margin-left: 10px;
  width: 18px;

  .mobile {
    display: block;

    @media ${device.tablet} {
      display: none;
    }
  }

  .desktop {
    display: none;

    @media ${device.tablet} {
      display: block;
    }
  }
`;

export const NotationContainer = styled.div`
  border-radius: 2px;
  display: inline-block;
  font-size: 12px;
  font-style: normal;
  font-weight: normal;
  position: relative;
  top: -3px;
`;

export const Badges = styled.div`
  background-color: ${color.light};
  border: solid 1px rgba(238, 74, 73, 0.5);
  border-radius: 2px;
  color: ${color.sunsetOrange};
  display: inline-block;
  font-size: 12px;
  font-style: normal;
  font-weight: normal;
  margin-left: 8px;
  padding: 0px 5px;
  position: relative;
  top: -5px;
  vertical-align: middle;

  > span {
    font-style: normal;
  }
`;

export const CompanyName = styled.div`
  margin-bottom: 5px;

  > h1 {
    color: ${color.highgray};
    font-family: "ProximaNovaRg";
    font-size: 14px;
    line-height: 15px;
    margin: 0;
    padding: 0;
  }
`;

export const CompanyNameContainer = styled.section`
  width: 100%;

  span.catalogs {
    display: inline-block;
    font-family: "ProximaNovaRg";
    font-size: 16px;
    font-weight: 700;
    max-width: calc(100% - 30px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  a {
    color: ${color.primary};
    display: block;
    font-size: 12px;
    font-weight: normal;
    max-width: 100%;
    overflow: hidden;
    padding-right: 7px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const CompanyTags = styled.div`
  font-size: 0;
  position: relative;

  span {
    border: 1px solid rgba(0, 171, 107, 0.3);
    border-radius: 2px;
    display: inline-block;
    margin-bottom: 5px;
    margin-right: 5px;
    padding: 0 5px;
    text-align: center;
  }

  a {
    display: block;
    font-weight: normal;
    padding: 2px 0;
  }
`;

export const ImageWrapper = styled(Flex)`
 margin: 0;

 @media ${device.tablet} {
    margin: auto;
    margin-top: 5px;
 }
`;

export const CompanyInfoWrapper = styled(Flex)`
  align-items: flex-start;
  background: ${color.light};
  border: none;
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: auto;
  line-height: 1.15;
  min-height: 65px;
  padding: 17.5px 20px 12.5px;
  position: relative;

  @media ${device.tablet} {
    align-items: center;
    border: 1px solid ${color.gainsboro};
    flex-direction: row;
    padding: 17.5px 20px 12.5px;
  }
`;

export const NewNotationTag = styled(Notation)`
  display: inline-block;
  margin-left: 4px;
`;

export const NewCorpActionTag = styled(CorpActionTag)`
  display: inline-block;
  margin-left: 4px;
`;

export const ExpandButtonToggleMobile = styled(ExpandButtonToggle)`
  display: block !important;
  position: absolute;
  top: 89px;
  right: 20px;

  @media ${device.tablet} {
    display: none !important;
    position: relative;
  }
`;

export const NotationCorpActionBarWrapper = styled(Flex)`
  ${({ isCompanyStock, isBoth }) => {
    return isCompanyStock ? css`
      background-color: ${color.light};
      flex-direction: column;
      
      > a {
        width: 100%;
      }

      @media ${device.tablet} {
        border-left: 1px solid ${color.gainsboro};
        border-right: 1px solid ${color.gainsboro};
        flex-direction: row;

        > div {
          flex-basis: ${isBoth ? '50%' : 'auto'};
        }

        > a {
          flex-basis: ${isBoth ? '50%' : 'auto'};
        } 
      }
    ` : css`
      background-color: transparent;
    `;
  }}
`;